import { idenityI18nKeys } from '../identity-i18n-keys';
import { identityConstants } from '../identity-constants';

export const en = {
    "UserName": "User Name",
    "Password": "Password",
    "RoleCode": "Role Code",
    "RoleName": "Role Name",
    "Operation": "Operation",
    "AddRole": "Add Role",
    "EditRole": "Edit Role",
    "Search": "Search",
    "Reset": "Reset",
    "Required": "Pleaen enter {0}",
    "Login": "Login",
    "Register": "Register",
    "ForgotPassword": "Forgot Password",
    "Permissions": "Permissions"
}

// var a = function () {
//     let obj = {};
//     obj[""] = "ddd";
//     return obj;
// }();